import { DriverViewFilterPipe } from './core/driver-view-filter.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DisplayComponent } from './display/display.component';
import { SearchViewComponent } from './sidebar/search-view/search-view.component';
import { DriverListComponent } from './display/driver-list/driver-list.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { TableFilterPipe } from './core/table-filter.pipe';
import { TimePipe } from './core/time.pipe';
import { ArrayFilterPipe } from './core/array-filter.pipe';



@NgModule({
    declarations: [
        AppComponent,
        SidebarComponent,
        DisplayComponent,
        SearchViewComponent,
        DriverListComponent,
        SpinnerComponent,
        TableFilterPipe,
        TimePipe,
        ArrayFilterPipe,
        DriverViewFilterPipe
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        NgbModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBIaXIrpj242DsPMXKUiX3MbzKRyKloQkY',
            libraries: ['places']
        }),
        AgmDirectionModule,
        BrowserAnimationsModule
    ],
    providers: [],
    exports: [
        TableFilterPipe,
        TimePipe,
        ArrayFilterPipe,
        DriverViewFilterPipe
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
